const nodeEnv = process.env.NODE_ENV;

const map = {
  car_image_path: [
    'http://localhost:9001/upload/',
    '/api/upload/',
  ],
  base_api: [
    '/api',
    '/api',
  ],
  captcha_url: [
    '/api/verify/captcha',
    '/api/verify/captcha',
  ],
};

function env(arr: any[]) {
  if (nodeEnv === 'production') {
    return arr[1];
  } else if (nodeEnv === 'development') {
    return arr[0];
  }
}

export const CAR_IMAGE_PATH = env(map.car_image_path);
export const BASE_API = env(map.base_api);
export const CAPTCHA_URL = env(map.captcha_url);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/env.ts